module.exports = __webpack_public_path__ + "ionicons.d9496a234c81179afbca.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/RvlxAdmin/Desktop/Sayali-Shupple-Code/Shupple-admin/~/ionicons/dist/fonts/ionicons.svg?v=3.0.0-alpha.3
// module id = ../../../../ionicons/dist/fonts/ionicons.svg?v=3.0.0-alpha.3
// module chunks = 2